export default {
  _name: 'court',
  _appearance: 'light',

  accent: '#FF9780',
  accentStart: '#FFB36D',
  accentEnd: '#FF8888',
  accentContent: '#FFFFFF',

  selected: '#FF9780',
  selectedContent: '#FFFFFF',
  selectedDisabled: '#C4CDD5',

  tagIndicator: '#FFF5F1',
  tagIndicatorContent: '#CD625C',

  tagActivity: '#FF9780',
  tagActivityContent: '#FFFFFF',

  surfaceOpened: '#FF8D86',
  surfaceUnder: '#F9FAFC',
}
